import React, { Suspense, useEffect } from 'react'
import './App.css'
import { Routes, Route } from 'react-router-dom'
import { Login } from './containers/Login'
import { ProtectedContainer } from './containers/Protected'
import { QueryClientProvider, QueryClient } from 'react-query'
import { PopupProvider } from './context/popupContext'
import { FallbackLoader } from './components/fallbackLoader'
import { useAuth } from './context/authContext'
import { ResetPassword } from './containers/resetPassword'
import { NotificationBarProvider } from './context/notificationContext'
import { BulkLabelGenerationProvider } from './context/bulkLabelGenerationContext'
import { BulkLabelGenerationProgress } from './components/BulkLabelGenerationProgress'
import ErrorBoundary from 'components/ErrorBoundary'
const ProtectedRoute = React.lazy(() => import('./components/protectedRoute'))

const client = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 0
        }
    }
})
function App() {
    const auth = useAuth()
    useEffect(() => {
        if (auth?.darkTheme) {
            document.firstElementChild?.classList.add("dark")
        }
        else {
            document.firstElementChild?.classList.remove("dark")
        }
    }, [auth?.darkTheme])
    return (
        <QueryClientProvider client={client}>
            <div className="bg-slate-100 dark:bg-slate-700 text-slate-700 text-sm min-h-[100vh] flex">
                <NotificationBarProvider>
                    <BulkLabelGenerationProvider>
                        <PopupProvider>
                            <ErrorBoundary>
                            <BulkLabelGenerationProgress />
                            <Routes>
                                <Route path="/login" element={<Login />} />
                                <Route path="/reset-password/:verifyKey" element={<ResetPassword />} />
                                <Route
                                    path="/*"
                                    element={
                                        <Suspense fallback={<FallbackLoader />}>
                                            <ProtectedRoute>
                                                <ProtectedContainer />
                                            </ProtectedRoute>
                                        </Suspense>
                                    }
                                />
                            </Routes>
                            </ErrorBoundary>
                        </PopupProvider>
                    </BulkLabelGenerationProvider>
                </NotificationBarProvider>
            </div>
            {/* <ReactQueryDevtools initialIsOpen={false} position="bottom-right"  /> */}
        </QueryClientProvider>
    )
}

export default App
